import httpManager from "@/app/shared/utils/httpManager";

export async function fetchLoggedUser(data) {
  if (data) {
    const response = await httpManager.get(`/users/${data.id}/`);
    return response.data;
  }
}
